import React from 'react'
import { ArrowBackIcon } from '~shared/icons/arrow-back'
import { ArrowUpIcon } from '~shared/icons/arrow-up'

export const EmploymentHelp = () => {
  const employmentHelpData = [
    {
      id: 1,
      text: 'Для тех, кто уже развивается в сфере психологического консультирования',
      img: '/assets/imgs/psychology-course-page/target-audience_1.jpg',
      alt: 'митм для кого эта программа 1'
    },
    {
      id: 2,
      text: 'Для желающих получить профессию психолога-консультанта с нуля',
      img: '/assets/imgs/psychology-course-page/target-audience_2.jpg',
      alt: 'митм для кого эта программа 2'
    },
    {
      id: 3,
      text: 'Для учителей, социальных работников и других профессионалов',
      img: '/assets/imgs/psychology-course-page/target-audience_3.jpg',
      alt: 'митм для кого эта программа 3'
    },
    {
      id: 4,
      text: 'Для тех, кто хочет получить знания в сфере психологии',
      img: '/assets/imgs/psychology-course-page/target-audience_4.jpg',
      alt: 'митм для кого эта программа 4'
    }
  ]
  return (
    <section className='bg-[#7D5EE4] rounded-[64px] min-h-[800px] mt-[80px] py-[80px]'>
      <div className='container container-slim box-border'>
        <h2 className='typo-section-heading typo-section-heading-mb text-white'>
          Для кого эта программа
        </h2>
        <div className='grid grid-cols-2 gap-[16px]'>
          {employmentHelpData.map(el => (
            <div
              key={el.id}
              className='bg-white rounded-[24px] p-[24px] flex gap-[24px] '>
              <img src={el.img} className='h-[276px] w-[276px]' />
              <div className='flex flex-col justify-between group  cursor-pointer'>
                <p>0{el.id}.</p>
                <p className='text-[24px]/[100%] font-medium '>{el.text}</p>
                <span className='w-[50px] h-[50px] rounded-full bg-[#E7E1FA] self-end inline-flex items-center justify-center group-hover:bg-[#7D5EE4] duration-300 ease-out'>
                  <ArrowUpIcon className='rotate-[135deg] h-[20px] w-[15px] text-[#7D5EE4] group-hover:text-white duration-300 ease-out' />
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
